import { getRealmFromSubDomain } from '../services/oidc.service'

export function getRealmId(): string | null {
  return getRealmFromSubDomain() ?? localStorage.getItem('realmId')
}

export function shouldShowMovedMessage(): boolean {
  return getRealmFromSubDomain() === null && !localStorage.getItem('internalZynkaUser')
}

// The org-flow's shared Keycloak realm, reached via the digitalbuildings.ai apex
// domain (see getRealmFromSubDomain), as opposed to a per-customer realm.
export const ORG_FLOW_REALM_ID = 'digitalbuildings'

export function isOrgFlowRealm(realmId: string | null): boolean {
  return realmId === ORG_FLOW_REALM_ID
}
